import React, { useEffect } from 'react';
import { CgArrowTopRight } from "react-icons/cg";
import blogImg1 from "../assets/images/recentblog1.jpg"
import { Link, useParams } from 'react-router-dom';
import config from '../config';
import AOS from "aos";
import fp2Content from '../JSONData/featuredProperties2.json';

const FeaturedProperties2 = ({ customclasses, data, properties = [] }) => {

    useEffect(() => {
        AOS.init({});
        AOS.refresh();
    }, []);
    const { lang } = useParams();
    const labels = (fp2Content && fp2Content[lang]) ? fp2Content[lang] : fp2Content.en;

    const getProjectUrl = (slug) => {
        return lang ? `/${lang}/project/${slug}` : `/project/${slug}`;
    };

    return (
        <>
            <div className={`featured-property-section ${customclasses}`}>
                <div className='container'>

                    <div className='grid-blocks d-flex flex-wrap sm-flex-column row-gap-50 d-row-gap-80 d-col-gap-70 d-gap-50 featured-properties'>
                        {/* {data === '1' ? <> */}

                        {properties[0] ?
                            <div className='grid-block d-pt-130'>
                                <div className='featured-property-item layout-1 w-100' data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
                                    <Link to={getProjectUrl(properties[0]?.slug)}>
                                        <div className='image-block position-relative overlay d-flex align-end justify-start'>
                                            <img src={config?.BASE_URL + properties[0]?.featuredImage} className='cover position-absolute top-0 start-0' />
                                            <video className='cover position-absolute top-0 start-0' ></video>
                                            <div className="summary-block pb-30 text-left pe-20 ps-30 d-pe-0 d-ps-50 position-relative">
                                                <div className='h6 mb-15'>
                                                    {/* {properties[0]?.location} */}
                                                    {properties[0]?.location ? properties[0]?.location === 'undefined' ? '' : properties[0]?.location : ''}


                                                </div>
                                                <div className='h2 fw-300 mb-15'>{properties[0]?.title}</div>
                                                <Link to={getProjectUrl(properties[0]?.slug)} className='button gap-10'>{labels.viewMore}<CgArrowTopRight /></Link>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            : <></>}
                        {properties[1] ?
                            <div className='grid-block'>
                                <div className='featured-property-item layout-2 w-100' data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
                                    <Link to={getProjectUrl(properties[1]?.slug)}>
                                        <div className='image-block position-relative overlay d-flex align-end justify-start'>
                                            <img src={config?.BASE_URL + properties[1]?.featuredImage} className='cover position-absolute top-0 start-0' />
                                        </div>
                                    </Link>
                                    <div className="summary-block text-left position-relative pt-30 d-pt-40">
                                        <div className='h6 mb-15'>
                                            {/* {properties[1]?.location} */}
                                            {properties[1]?.location ? properties[1]?.location === 'undefined' ? '' : properties[1]?.location : ''}

                                        </div>
                                        <div className='h2 fw-300 mb-15'>{properties[1]?.title}</div>
                                        <Link to={getProjectUrl(properties[1]?.slug)} className='button gap-10'>{labels.viewMore}<CgArrowTopRight /></Link>

                                    </div>
                                </div>
                            </div> : <></>}
                        {/* </>  */}
                        {/* // : <></>} */}
                        {/* {data === '2' ? <> */}
                        {properties[2] ?

                            <div className='grid-block d-pt-130'>
                                <div className='featured-property-item layout-2 w-100' data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
                                    <Link to={getProjectUrl(properties[2]?.slug)}>
                                        <div className='image-block position-relative overlay d-flex align-end justify-start'>
                                            <img src={config?.BASE_URL + properties[2]?.featuredImage} className='cover position-absolute top-0 start-0' />
                                        </div>
                                    </Link>
                                    <div className="summary-block text-left position-relative pt-30 d-pt-40">
                                        <div className='h6 mb-15'>
                                            {/* {properties[2]?.location} */}
                                            {properties[2]?.location ? properties[2]?.location === 'undefined' ? '' : properties[2]?.location : ''}

                                        </div>
                                        <div className='h2 fw-300 mb-15'>{properties[2]?.title}</div>
                                        <Link to={getProjectUrl(properties[2]?.slug)} className='button gap-10'>{labels.viewMore}<CgArrowTopRight /></Link>
                                    </div>
                                </div>
                            </div>
                            : <></>
                        }
                        {properties[3] ?
                            <div className='grid-block '>
                                <div className='featured-property-item layout-1 w-100' data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
                                    <Link to={getProjectUrl(properties[3]?.slug)}>
                                        <div className='image-block position-relative overlay d-flex align-end justify-start'>
                                            <img src={config?.BASE_URL + properties[3]?.featuredImage} className='cover position-absolute top-0 start-0' />
                                            <div className="summary-block pb-30 text-left pe-20 ps-30 d-pe-0 d-ps-50 position-relative">
                                                <div className='h6 mb-15'>
                                                    {/* {properties[3]?.location} */}
                                                    {properties[3]?.location ? properties[3]?.location === 'undefined' ? '' : properties[3]?.location : ''}

                                                </div>
                                                <div className='h2 fw-300 mb-15'>{properties[3]?.title}</div>
                                                <Link to={getProjectUrl(properties[3]?.slug)} className='button gap-10'>{labels.viewMore}<CgArrowTopRight /></Link>

                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div> : <></>
                        }

                        {/* </> : <>
                        </>} */}


                    </div>
                    <div className='grid-blocks d-flex flex-wrap sm-flex-column row-gap-50 d-row-gap-80 d-col-gap-70 d-gap-50 featured-properties'>

                        {properties[4] ?
                            <div className='grid-block d-pt-130'>
                                <div className='featured-property-item layout-1 w-100' data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
                                    <Link to={getProjectUrl(properties[4]?.slug)}>
                                        <div className='image-block position-relative overlay d-flex align-end justify-start'>
                                            <img src={config?.BASE_URL + properties[4]?.featuredImage} className='cover position-absolute top-0 start-0' />
                                            <video className='cover position-absolute top-0 start-0' ></video>
                                            <div className="summary-block pb-30 text-left pe-20 ps-30 d-pe-0 d-ps-50 position-relative">
                                                <div className='h6 mb-15'>
                                                    {/* {properties[4]?.location} */}
                                                    {properties[4]?.location ? properties[4]?.location === 'undefined' ? '' : properties[4]?.location : ''}

                                                </div>
                                                <div className='h2 fw-300 mb-15'>{properties[4]?.title}</div>
                                                <Link to={getProjectUrl(properties[4]?.slug)} className='button gap-10'>{labels.viewMore}<CgArrowTopRight /></Link>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            : <></>}
                        {properties[5] ?
                            <div className='grid-block'>
                                <div className='featured-property-item layout-2 w-100' data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
                                    <Link to={getProjectUrl(properties[5]?.slug)}>
                                        <div className='image-block position-relative overlay d-flex align-end justify-start'>
                                            <img src={config?.BASE_URL + properties[5]?.featuredImage} className='cover position-absolute top-0 start-0' />
                                        </div>
                                    </Link>
                                    <div className="summary-block text-left position-relative pt-30 d-pt-40">
                                        <div className='h6 mb-15'>
                                            {/* {properties[5]?.location} */}
                                            {properties[5]?.location ? properties[5]?.location === 'undefined' ? '' : properties[5]?.location : ''}

                                        </div>
                                        <div className='h2 fw-300 mb-15'>{properties[5]?.title}</div>
                                        <Link to={getProjectUrl(properties[5]?.slug)} className='button gap-10'>{labels.viewMore}<CgArrowTopRight /></Link>

                                    </div>
                                </div>
                            </div> : <></>}

                    </div>
                </div>
            </div>
        </>
    )
}

export default FeaturedProperties2